// import { useLayoutEffect } from "react";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Col,
  Row,
  Form,
  ToastContainer,
  Toast,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Store } from "../../Store";
// import { usePaystackPayment  } from "react-paystack";
import axios from "axios";
import { getError } from "../../Utils/GetErrors";
import ConfirmIt from "../../Utils/ConfirmIt";
import Modal from 'react-bootstrap/Modal';

function StoreScreen() {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const {
    userInfo,
    baseUrl,
    CurrUser,
    products,
  } = state;
  const [showToast, setShowToast] = useState(false);
  const [message, setMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("");

  const [afaData, setAfaData] = useState({
    name: "",
    phone: "",
    card: "",
    dob: "",
    location: "",
  });

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedPackage, setSelectedPackage] = useState("");

  const [currentProduct, setCurrentProduct] = useState(null);

    const [showConfirm, setShowConfirm] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [confirmAction, setConfirmAction] = useState(null);
      // const [NowOrder, setNowOrder] = useState(null);

  const navigate = useNavigate();
  const networkFromUrl = window.location.pathname.split("/").pop();
  
  // console.log('net',networkFromUrl)
  // Clear the phone number and selected package when the modal is closed
  // useEffect(() => {
  //   if (!props.show) {
  //     setPhoneNumber("");
  //     setSelectedPackage("");
  //   }
  // }, [props.show]);

  // filter product based on selected network from store
  useEffect(() => {
    if (networkFromUrl) {
      const product = products.find((p) => p.network === networkFromUrl);
      setCurrentProduct(product);
    }
  }, [networkFromUrl, products]);

  // HANDLERS
  const handlePackage = (e) => {
    setSelectedPackage(e.target.value);
  };

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const getAmountFromPackage = (pkg) => {
    const amount = pkg.split(" - ")[1];
    return parseFloat(amount); // Convert to float to accommodate decimal values
  };

  const getOfferFromPackage = (pkg) => {
    const Offer = pkg.split(" - ")[0];
    return Offer;
  };

  // New variable to pick numbers in the getOfferFromPackage and multiply by 1000
  // const offer = getOfferFromPackage(selectedPackage);
  // const offerMatch = offer.match(/\d+/);
  // const calculatedDataOffer =
  //   networkFromUrl === "MTNup2u" || networkFromUrl ==="MTNme2u"
  //   || networkFromUrl === "MTNexpress" || networkFromUrl === "AT-ishare" 
  //   || networkFromUrl === "AirtelTigo" || networkFromUrl === "Telecel"
  //     ? offerMatch
  //       ? parseFloat(offerMatch[0], 10) * 1000
  //       : 0
  //     : null;

    // GO TO TOPUP PAGE - FOR WALLET FUNCTION
    const GoToTopup = () => {
      setMessage("Please complete the topup before you order");
      setToastVariant("primary");
      setShowToast(true);
      setTimeout(() => {
        navigate("/home/topup");
        // props.onHide();
      }, 2000);
    };
    
    const GoToPay = async () => {
      setShowConfirm(true);
      setAlertMessage("Are you sure you want to make payment?");
      setConfirmAction(()=>async () => {
        setShowConfirm(false);
        if (CurrUser.balance >= getAmountFromPackage(selectedPackage)) {
          let chosenId = CurrUser._id;
          try {
            const { data } = await axios.put(
              `${baseUrl}/user/balance`,
              { amount: -getAmountFromPackage(selectedPackage), chosenId },
              {
                headers: { Authorization: `Bearer ${userInfo.token}` },
              }
            );
            ctxDispatch({
              type: "USER_RECHARGE",
              payload: data.balance,
            });
            await handlePaystackSuccessAction(
              Math.floor(Math.random() * 99999999)
            );

          } catch (error) {
            setMessage(getError(error));
            setToastVariant("danger");
            setShowToast(true);
          }
        } else {
          setMessage("Insufficient balance. Please top up your wallet.");
          setToastVariant("danger");
          setShowToast(true);
          setTimeout(() => {
            GoToTopup();
          }, 2000);
        }
      });
  };

  // PAYMENT HANDLERS
  const handlePaystackSuccessAction = async (reference) => {
    setMessage("Purchase made successfully");
    setToastVariant("success");
    setShowToast(true);
    // SAVE ORDER
    try {
      // Get the current date and time
      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleString('en-GB', { timeZone: 'UTC', hour12: false });

      const newOrder = {
        // id: newOrderId,
        items: afaData,
        totalAmount: getAmountFromPackage(selectedPackage), // Convert back to original currency
        date: formattedDate,
        reference: reference.reference || reference,
        receiver: phoneNumber || afaData.phone,
        offer: getOfferFromPackage(selectedPackage),
        network: networkFromUrl,
        user: userInfo.username,
        status: "pending", // Set status to pending,
        actionTimestamp: null, // Initialize as null
      };
      const { data } = await axios.post(
        `${baseUrl}/order/create`,
        { newOrder },
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        }
      );
      localStorage.setItem('nowToProcess',data.order._id);
      // setNowOrder(data.order._id);
      // Update the order history in the global state
      ctxDispatch({
        type: "ORDER_HISTORY_UPDATE",
        payload: [...state.orderHistory, data.order],
      });

      //ONLINE Increment the last order ID on the server
      // await axios.post(`${baseUrl}/order/incrementLastOrderId`);

      // setMessage("Your order is placed successfully");
      // setToastVariant("success");
      // setShowToast(true);


      // setTimeout(() => {
      //   ctxDispatch({ type: "CART_CLEAR" });
      //   // props.onHide();
        navigate("/home/my-transactions");
      // }, 2000);
    } catch (error) {
      setMessage(getError(error));
      setToastVariant("danger");
      setShowToast(true);
    }
    // SEND ADMIN SMS
    function sendSMS(phoneNumber) {
      const orderedPackageS = parseFloat(getOfferFromPackage(selectedPackage));
      if (orderedPackageS && phoneNumber) {
        try {
          const apiUrl = `https://apps.mnotify.net/smsapi?key=zwNY4rjo1XWnMXn8Om7Q8gk1U&to=233548785316&msg=Someone just requested ${orderedPackageS}GB data bundle to ${phoneNumber}&sender_id=KYE-TECH`;
          fetch(apiUrl).then((response) => response.json(response.data));
        } catch (error) {
          console.error("Error sending SMS:", error);
        }
      }
    }
    sendSMS(phoneNumber);

   if (networkFromUrl === "AFA") {
      // SEND ADMIN SMS
      function sendSMS(phoneNumber) {
        if (afaData.phone) {
          try {
            const apiUrl = `https://apps.mnotify.net/smsapi?key=zwNY4rjo1XWnMXn8Om7Q8gk1U&to=233548785316&msg=Someone just requested for AFA with this details ${afaData.name} - ${afaData.phone} - ${afaData.card} - ${afaData.dob} - ${afaData.location}&sender_id=KYE-TECH`;
            fetch(apiUrl).then((response) => response.json(response.data));
          } catch (error) {
            console.error("Error sending SMS:", error);
          }
        }
      }
      sendSMS(phoneNumber);
} 
else {
     console.log(networkFromUrl) 
  };
}

  const formContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    flexDirection: "column",
  };
  const formContainer = {
    width: window.innerWidth < 768 ? '90vw' : '50vw',
    border: "1px solid transparent",
    padding: "20px",
    borderRadius: "10px",
    alignItems: "center",
    // backgroundColor: "whitesmoke",
  };

  useEffect(() => {
    if (networkFromUrl === "AFA" && currentProduct) {
      const defaultPackage = currentProduct.packages[0];
      if (defaultPackage) {
        setSelectedPackage(`${defaultPackage.offer} - ${
          userInfo.userLevel === "Customer"
            ? defaultPackage.priceCustomer
            : defaultPackage.priceAgent
        }`);
      }
    }
  }, [networkFromUrl, currentProduct, userInfo.userLevel]);

  return (
    <div style={{formContainerStyle}}>
    {networkFromUrl === "AFA" ? (
      <div style={formContainer} className="container mt-3 bg-warning-subtle border col-11 col-md-6">
                    <Row className="justify-content-center">
              <Col xs={12} md={6} className="text-center">
                <b className="fs-3" style={{textTransform:'uppercase'}}>{currentProduct && currentProduct.network}</b>
              </Col>
            </Row>
        <Form>
          <Form.Group className="mb-1" controlId="formInput1">
            <Form.Label>Full name</Form.Label>
            <Form.Control 
              type="text" 
              placeholder="name" 
              value={afaData.name}
              onChange={(e) => setAfaData({ ...afaData, name: e.target.value })}
            />
          </Form.Group>

          <Form.Group className="mb-1" controlId="formInput2">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control 
              type="text" 
              placeholder="phone" 
              value={afaData.phone}
              onChange={(e) => setAfaData({ ...afaData, phone: e.target.value })}
            />
          </Form.Group>

          <Form.Group className="mb-1" controlId="formInput3">
            <Form.Label>Ghana Card</Form.Label>
            <Form.Control 
              type="text" 
              placeholder="card number" 
              value={afaData.card}
              onChange={(e) => setAfaData({ ...afaData, card: e.target.value })}
            />
          </Form.Group>

          <Form.Group className="mb-1" controlId="formInput4">
            <Form.Label>Date of birth</Form.Label>
            <Form.Control 
              type="text" 
              placeholder="dob" 
              value={afaData.dob}
              onChange={(e) => setAfaData({ ...afaData, dob: e.target.value })}
            />
          </Form.Group>

          <Form.Group className="mb-1" controlId="formInput5">
            <Form.Label>Location</Form.Label>
            <Form.Control 
              type="text" 
              placeholder="location" 
              value={afaData.location}
              onChange={(e) => setAfaData({ ...afaData, location: e.target.value })}
            />
          </Form.Group>
        </Form>
        <Row className="justify-content-center mt-2 fw-bold text-primary">                       
          {currentProduct &&
                        currentProduct.packages.map((p) => (
                          <option
                            key={p._id}
                            data={p}
                            value={`${p.offer} - ${
                              userInfo.userLevel === "Customer"
                                ? p.priceCustomer
                                : p.priceAgent
                            }`}
                          >
                           {p.offer} - &cent;{" "}
                            {userInfo.userLevel === "Customer"
                              ? p.priceCustomer
                              : p.priceAgent}
                          </option>
                        ))}
                        </Row>
        <Row className="text-center justify-content-center mt-1">
              <Col xs={12} md={6}>
                Wallet Bal:
                <strong> &cent; {CurrUser?.balance.toFixed(2)}</strong>
              </Col>
              <Col xs={12} md={6}>
                <span
                  onClick={GoToTopup}
                  style={{ cursor: "pointer", color: "red", padding: "1px" }}
                >
                  Topup your wallet here
                </span>
              </Col>
            </Row>

            <div className="text-center justify-content-center mt-3">
            <Button
            variant="success"
            className="w-100"
            // className="bg-lignt btn btn-light"
            // disabled={!selectedPackage || phoneNumber.length !== 10}
            onClick={GoToPay}
          >
            Pay
          </Button>
          {/* <Button
              variant="warning"
              className="ms-2"
              // disabled={!selectedPackage || phoneNumber.length !== 10}
              onClick={handlePaystackClick}
            >
              Pay with momo
            </Button> */}
          </div>
          {/* <div style={formContainer} className="text-center">
            <span style={{color:'#fff', backgroundColor:'red', padding:'5px', borderRadius:'8px', fontWeight:'bold'}} disabled>Notice Board</span>
            <p className="text-light fw-bold p-1 bg-dark">No charges for wallet payment where as external charges may apply to pay with momo</p>
          </div> */}
      </div>
    )
    :
  (
      <div style={formContainer} className="container mt-4 border bg-warning-subtle col-11 col-md-6" >
            <Row className="justify-content-center">
              <Col xs={12} md={6} className="text-center bg-dark text-light">
                <b className="fs-3" style={{textTransform:'uppercase'}}>{currentProduct && currentProduct.network}</b>
                {/* {currentProduct && (
                  <Image
                    src={currentProduct.image}
                    width="150px"
                    height="auto"
                    fluid
                  />
                )} */}
              </Col>
            </Row>
            {/* <Row /> */}
            <Row className="justify-content-center mt-3">
              {/* <Col xs={10} md={10}> */}
              <div className="col-9 col-md-6">
                <Form>
                  <Form.Group
                    className="mb-2"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label style={{color:'#1cfc03', backgroundColor:'#19850b', padding:'5px', borderRadius:'8px', fontWeight:'bold'}}>PACKAGE</Form.Label>
                    <Form.Select onChange={handlePackage}>
                      <option defaultValue>SELECT PACKAGE</option>
                      {currentProduct &&
                        currentProduct.packages.map((p) => (
                          <option
                            key={p._id}
                            data={p}
                            value={`${p.offer} - ${
                              userInfo.userLevel === "Customer"
                                ? p.priceCustomer
                                : p.priceAgent
                            }`}
                          >
                            {p.offer} - &cent;{" "}
                            {userInfo.userLevel === "Customer"
                              ? p.priceCustomer
                              : p.priceAgent}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group
                    className="mb-2"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label style={{color:'#f0e8ff', backgroundColor:'#230a52', padding:'5px', borderRadius:'8px', fontWeight:'bold'}}>BENEFICIARY</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter beneficiary number"
                      value={phoneNumber}
                      onChange={handlePhoneNumberChange}
                      maxLength="10"
                      inputMode="numeric"
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                      required
                    />
                  </Form.Group>
                </Form>
              </div>
              {/* </Col> */}
            </Row>

            <Row className="text-center justify-content-center mt-1">
              <Col xs={12} md={6}>
                Wallet Bal:
                <strong> &cent; {CurrUser?.balance.toFixed(2)}</strong>
              </Col>
              <Col xs={12} md={6}>
                <span
                  onClick={GoToTopup}
                  style={{ cursor: "pointer", color: "red", padding: "1px" }}
                >
                  Topup your wallet here
                </span>
              </Col>
            </Row>

            <div className="text-center justify-content-center mt-3">
            <Button
            variant="success"
            className="border w-100"
            disabled={!selectedPackage || phoneNumber.length !== 10}
            onClick={GoToPay}
          >
            Pay
          </Button>
          {/* <Button
              variant="warning"
              className="ms-2"
              disabled={!selectedPackage || phoneNumber.length !== 10}
              onClick={handlePaystackClick}
            >
              Pay with momo
            </Button> */}
          </div>
          {/* <div style={formContainer} className="text-center">
            <span style={{color:'#fff', backgroundColor:'red', padding:'5px', borderRadius:'8px', fontWeight:'bold'}} disabled>Notice Board</span>
            <p className="text-light fw-bold p-1 bg-dark" >No charges for wallet payment where as external charges may apply to pay with momo</p>
          </div> */}
      </div>
  )}
        <ConfirmIt
          Message={alertMessage}
          ShowConfirm={showConfirm}
          OnClose={() => setShowConfirm(false)}
          // onConfirm={confirmActionHandler}
          onConfirm={confirmAction}
        />
      {/* TOAST SETUP */}
      <ToastContainer
        className="p-3 d-inline-block m-1 position-fixed"
        position="top-center"
        style={{ zIndex: 9999 }}
      >
        <Toast
          bg={toastVariant || "warning"}
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
        >
          <Toast.Header closeButton={false}>
            <strong className="me-auto">Notice</strong>
            {/* <small>11 mins ago</small> */}
          </Toast.Header>
          <Toast.Body className="text-white">{message}</Toast.Body>
        </Toast>
      </ToastContainer>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>NOTICE</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        Currently, MTN Express is not accepting new numbers. Please try MTNUp2U or MTNMe2U. Thank you.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary">Understood</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default StoreScreen;